
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitopimprichichwadcab() {



    const cardData =
    {
        keyword: 'Mumbai to Pimpri Chinchwad Cab',
        heading: 'Vedant Travels: Mumbai to Pimpri Chinchwad Cab  ',
        headingDescription: 'Vedant Travels offers affordable, reliable, and comfortable taxi services for your journey from Mumbai to Pimpri Chinchwad. We provide a range of vehicles, from sedans to SUVs and premium cabs, ensuring a smooth and hassle-free ride. Our transparent pricing and professional drivers guarantee a stress-free journey.',

        top: 'Top Places to Visit in Pimpri Chinchwad with Vedant Travels',

        "topPlaces": [
            {
                "title": "Sri Balaji Mandir",
                "description": "Located in the heart of Pimpri Chinchwad, Sri Balaji Mandir is one of the most revered temples in the area. Dedicated to Lord Venkateswara, the temple’s serene atmosphere makes it a peaceful place for spiritual reflection and devotion."
            },
            {
                "title": "Rama Temple",
                "description": "This beautiful temple in Pimpri is dedicated to Lord Rama. It is a place of peace and devotion, making it an important spiritual landmark in the region. The temple’s tranquil environment provides visitors with a space for meditation and prayer."
            },
            {
                "title": "Phoenix Marketcity",
                "description": "Phoenix Marketcity is one of the most popular shopping and entertainment malls in Pimpri Chinchwad. With a wide range of shopping, dining, and entertainment options, it’s a perfect place to relax and enjoy a day out with family or friends."
            },
            {
                "title": "Rajiv Gandhi Infotech Park",
                "description": "Known as a hub for the IT industry in Pune, Rajiv Gandhi Infotech Park in Hinjewadi is located close to Pimpri Chinchwad. It is a significant landmark in the area, hosting several tech companies and being an essential center for business and innovation."
            },
            {
                "title": "Chinchwad Railway Station",
                "description": "Chinchwad Railway Station is an important railway station in the Pimpri Chinchwad region. It connects the area to major cities in Maharashtra, and it’s a significant transportation hub for people traveling to and from Pune and Mumbai."
            },
            {
                "title": "Auto Cluster Development and Research Institute",
                "description": "The Auto Cluster Development and Research Institute in Pimpri Chinchwad is a key institution for research and development in the automotive sector. It's an essential destination for those interested in the future of the automobile industry in India."
            },
            {
                "title": "Pimpri Chinchwad Garden",
                "description": "A tranquil and serene park, the Pimpri Chinchwad Garden is perfect for nature lovers. Visitors can enjoy a peaceful walk, relax amidst greenery, or spend time with family in this well-maintained garden."
            },
            {
                "title": "Morya Gosavi Ganpati Temple",
                "description": "Located in the heart of Pimpri Chinchwad, Morya Gosavi Ganpati Temple is an important religious site. It is especially famous during the Ganesh Chaturthi festival, drawing thousands of devotees to seek blessings from Lord Ganesha."
            },
            {
                "title": "Sungavkar Lake",
                "description": "Sungavkar Lake is a scenic spot in Pimpri Chinchwad, ideal for nature lovers and those seeking a peaceful retreat. The lake provides a calming environment for a relaxed day out and is a great place for photography and birdwatching."
            },
            {
                "title": "The Pavillion Mall",
                "description": "Another popular shopping and entertainment destination in Pimpri Chinchwad, The Pavillion Mall offers a wide array of retail stores, dining options, and entertainment facilities. It’s an excellent place to shop, dine, and unwind with family and friends."
            }
        ],

"services": [
    {
        "name": "Mumbai to Pimpri Chinchwad Cab",
        "description": "Looking to travel from Mumbai to Pimpri Chinchwad? Vedant Travels offers reliable and comfortable cab services. Choose from a range of vehicles like Innova, Ertiga, and Sedans for a smooth and hassle-free journey to Pimpri Chinchwad."
    },
    {
        "name": "Mumbai to Pimpri Akurdi Cab",
        "description": "Traveling from Mumbai to Pimpri Akurdi? Vedant Travels provides convenient and affordable cab services. Whether you prefer an Innova, Ertiga, or Sedan, our vehicles offer comfort and safety for your journey from Mumbai to Pimpri Akurdi."
    },
    {
        "name": "Mumbai Airport to Pimpri Chinchwad",
        "description": "Book a taxi from Mumbai Airport to Pimpri Chinchwad with Vedant Travels. Our professional drivers ensure you a comfortable and timely ride. With options like Innova, Ertiga, and Sedans, you can enjoy a stress-free journey to Pimpri Chinchwad from the airport."
    },
    {
        "name": "Mumbai to Pimpri Chinchwad One Way Cab",
        "description": "If you're looking for a one-way taxi from Mumbai to Pimpri Chinchwad, Vedant Travels offers the perfect solution. Our fleet includes spacious vehicles like Innova, Ertiga, and Sedans to ensure a comfortable and smooth ride at an affordable price."
    },
    {
        "name": "Mumbai to Pimpri Chinchwad Taxi Fare",
        "description": "The Mumbai to Pimpri Chinchwad Taxi Fare with Vedant Travels is competitive and transparent. We offer a variety of vehicle options, including the luxurious Innova, Ertiga, and Sedans, ensuring a smooth journey with no hidden charges."
    },
    {
        "name": "Dadar to Pimpri Chinchwad Cab",
        "description": "For a smooth and reliable ride from Dadar to Pimpri Chinchwad, choose Vedant Travels. We offer a variety of vehicles to suit your needs, including Innova, Ertiga, and Sedans, ensuring a safe and comfortable journey."
    },
    {
        "name": "Andheri to Pimpri Chinchwad Cab",
        "description": "Traveling from Andheri to Pimpri Chinchwad? Vedant Travels offers efficient and comfortable cab services. Whether you're traveling alone or with a group, our vehicles like Innova, Ertiga, and Sedans ensure a smooth and timely ride."
    },
    {
        "name": "Mumbai to Pimpri Chinchwad Innova Cab",
        "description": "For a luxurious and spacious ride, book the Mumbai to Pimpri Chinchwad Innova Cab with Vedant Travels. The Innova offers premium comfort and ample space, making it perfect for families or business travelers seeking a smooth journey."
    },
    {
        "name": "Mumbai to Pimpri Chinchwad Ertiga Cab",
        "description": "The Mumbai to Pimpri Chinchwad Ertiga Cab service is an ideal choice for small groups or families. The Ertiga offers ample space and comfort at an affordable price. Book with Vedant Travels for a smooth and relaxing ride to Pimpri Chinchwad."
    },
    {
        "name": "Mumbai to Pimpri Chinchwad Taxi Fare",
        "description": "The Mumbai to Pimpri Chinchwad Taxi Fare with Vedant Travels is designed to be competitive and transparent. Whether you're choosing an Innova, Ertiga, or Sedan, we guarantee an affordable fare and a high-quality, comfortable ride."
    },
    {
        "name": "Mumbai to Pimpri Chinchwad Cab",
        "description": "Vedant Travels offers reliable and comfortable Mumbai to Pimpri Chinchwad cab services. Our experienced drivers and well-maintained vehicles, including Innova, Ertiga, and Sedans, ensure a smooth and stress-free journey."
    },
    {
        "name": "Mumbai to Baner Cab",
        "description": "Traveling from Mumbai to Baner? Vedant Travels provides a variety of vehicles for a comfortable journey. Whether you need an Innova, Ertiga, or Sedan, we guarantee a safe and reliable ride from Mumbai to Baner."
    },
    {
        "name": "Mumbai to Wakad Cab",
        "description": "Need a cab from Mumbai to Wakad? Vedant Travels offers reliable and affordable cab services for this route. Choose from our fleet of vehicles, including Innova, Ertiga, and Sedans, for a comfortable and timely journey to Wakad."
    },
    {
        "name": "Mumbai Airport to Pune Taxi Fare",
        "description": "The Mumbai Airport to Pune Taxi Fare with Vedant Travels is competitive and transparent. We offer a variety of vehicle options, including Sedans, Ertiga, and Innova, ensuring a smooth and comfortable ride to Pune from the airport."
    },
    {
        "name": "Mumbai to Akurdi Cab",
        "description": "Traveling from Mumbai to Akurdi? Vedant Travels provides efficient and comfortable cab services. Choose from our fleet of well-maintained vehicles, including Innova, Ertiga, and Sedans, and enjoy a smooth journey to Akurdi."
    },
    {
        "name": "Mumbai to Pune Cab Booking",
        "description": "Book your Mumbai to Pune cab with Vedant Travels for an affordable, comfortable, and reliable ride. We offer a range of vehicles, including Sedans, Ertiga, and Innova, for a smooth journey from Mumbai to Pune."
    }
],


"tableData": [
    ["Mumbai to Pimpri Chinchwad Cab", "Mumbai to Pimpri Akurdi Cab"],
    ["Mumbai Airport to Pimpri Chinchwad", "Mumbai to Pimpri Chinchwad One Way Cab"],
    ["Mumbai to Pimpri Chinchwad Taxi Fare", "Dadar to Pimpri Chinchwad Cab"],
    ["Andheri to Pimpri Chinchwad Cab", "Mumbai to Pimpri Chinchwad Innova Cab"],
    ["Mumbai to Pimpri Chinchwad Ertiga Cab", "Mumbai to Pimpri Chinchwad Ertiga Cab"],
    ["Mumbai to Pimpri Chinchwad Taxi Fare", "Mumbai to Pimpri Chinchwad Cab"],
    ["Mumbai to Baner Cab", "Mumbai to Wakad Cab"],
    ["Mumbai Airport to Pune Taxi Fare", "Mumbai to Akurdi Cab"],
    ["Mumbai to Pune Cab Booking", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we prioritize your time. Whether it’s a business trip or a family visit, we ensure timely pickups and drop-offs for your Mumbai to Pimpri Chinchwad Cab. You can count on us for a hassle-free and punctual experience."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "We offer a fleet of well-maintained, comfortable, and spacious vehicles for your Mumbai to Pimpri Chinchwad journey. Choose from sedans, SUVs, and premium cars, all designed for maximum comfort with air conditioning, ample legroom, and plush seating."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly trained, experienced, and well-versed with long-distance routes. For your Mumbai to Pimpri Chinchwad ride, our drivers ensure that your trip is smooth, safe, and efficient, allowing you to sit back and relax during your journey."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer affordable rates with no hidden charges for your Mumbai to Pimpri Chinchwad Cab journey. Our transparent pricing ensures that you get the best value for your money, with clear details on all charges before booking."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features, such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, ensuring a secure and comfortable journey from Mumbai to Pimpri Chinchwad."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether it’s an early morning flight or a late-night return, Vedant Travels is available 24/7. Book your Mumbai to Pimpri Chinchwad Cab at any time, and our customer service team will assist you promptly."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Pimpri Chinchwad Cab is quick and easy. You can book online through our website or mobile app, or simply reach out to our customer service team for assistance, making the entire process smooth and convenient."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer customized travel packages for your Mumbai to Pimpri Chinchwad journey, whether you're traveling for business, leisure, or special events. Let us know your preferences, and we’ll tailor the trip to ensure a pleasant and comfortable experience."
    }
  ]






    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Pimpri Chinchwad cab with Vedant Travels?',
            answer: 'You can easily book your Mumbai to Pimpri Chinchwad Cab through our website or mobile app. Alternatively, you can contact our customer service team for personalized booking assistance.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly experienced and skilled in handling long-distance routes like Mumbai to Pimpri Chinchwad. They ensure a smooth, safe, and timely journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai to Pimpri Chinchwad travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars. All our vehicles are well-maintained and designed for a comfortable ride with ample space.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Pimpri Chinchwad cab rental?',
            answer: 'We accept multiple payment options, including cash, credit/debit cards, and online payments via our app, giving you flexibility and convenience.',
        },
        {
            id: 5,
            question: 'Can I book a return trip along with my Mumbai to Pimpri Chinchwad cab?',
            answer: 'Yes, you can book a round-trip cab for your Mumbai to Pimpri Chinchwad journey. Simply provide your return details when making the booking, and we will handle the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting or detours will be communicated upfront during the booking process, ensuring complete transparency in our pricing.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Pimpri Chinchwad after my drop-off?',
            answer: 'Yes, we offer customized sightseeing tours in Pimpri Chinchwad or nearby areas after your Mumbai to Pimpri Chinchwad trip. Visit popular landmarks and explore the city with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Pimpri Chinchwad cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or special requirements, please let us know during booking, and we will ensure your needs are met.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel between Mumbai and Pimpri Chinchwad?',
            answer: 'Yes, we offer corporate travel services for meetings, conferences, and other corporate events. We can tailor the service to your company’s needs, ensuring a smooth and efficient journey.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for my Mumbai to Pimpri Chinchwad journey?',
            answer: 'Vedant Travels provides reliable, safe, and comfortable travel services with experienced drivers, well-maintained vehicles, transparent pricing, and 24/7 availability. We ensure a smooth, comfortable, and enjoyable Mumbai to Pimpri Chinchwad experience.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Amit Deshmukh",
            title: "Business Traveler",
            quote: "I booked a Mumbai to Pimpri Chinchwad Cab with Vedant Travels, and I was impressed by the professionalism of the driver and the quality of the vehicle. The ride was smooth and on time. Highly recommended!",
            rating: 5,
        },
        {
            name: "Mrs. Neha Joshi",
            title: "Family Traveler",
            quote: "Our family used Vedant Travels for our trip from Mumbai to Pimpri Chinchwad. The car was spacious, clean, and comfortable. The driver was friendly and courteous, making it a great experience. We'll definitely use them again.",
            rating: 5,
        },
    ];
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pimpri Chinchwad Cab",
  "image": "https://vedanttravels.in/assets/images/mumbai-to-pimpri-chinchwad-cab.jpg",
  "description": "Book Mumbai to Pimpri Chinchwad cab with Vedant Travels for a safe, comfortable, and reliable ride. Choose from AC sedans, SUVs, and flexible one-way or round-trip options with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-to-pimpri-chinchwad-cab"
  }
};


      

    return (
        <div>
                 
    <Helmet>
  <title>Mumbai to Pimpri Chinchwad Cab | Safe & Reliable | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pimpri Chinchwad cab with Vedant Travels for a safe, comfortable, and reliable ride. Choose from AC sedans, SUVs, and flexible one-way or round-trip options with experienced drivers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pimpri Chinchwad Cab, Cab Mumbai to Pimpri Chinchwad, Taxi Mumbai to Pimpri Chinchwad, One-Way Cab Mumbai Pimpri, Round Trip Cab Mumbai Pimpri Chinchwad, AC Taxi Mumbai to Pimpri Chinchwad, SUV Cab Mumbai Pimpri Chinchwad, Vedant Travels Mumbai, Online Cab Booking Mumbai Pimpri, Reliable Cab Mumbai Pimpri, Comfortable Ride Mumbai Pimpri Chinchwad" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopimprichichwadcab;